import { HtmlDivProps } from 'framework/components/HtmlDivProps';
import React, { forwardRef } from 'react';

export type ColumnStackProps = Omit<HtmlDivProps, 'ref'> & {
	dfcol?: boolean;
	dfcolac?: boolean;
	jcc?: boolean;
	h100?: boolean;
	w100?: boolean;
	w50?: boolean;
	w30?: boolean;
	w33?: boolean;
	w70?: boolean;
	paper?: boolean;
	pointer?: boolean;
	borderBottomDivider?: boolean;
	preventDefault?: boolean;
	errorBorder?: boolean;
	mxauto?: boolean;
	popout?: boolean;
	popoverForm?: boolean;
};

function calculateStyle(props: ColumnStackProps): React.CSSProperties {
	let style = { ...props.style };
	if (props.dfcol === true) {
		style = { ...style, display: 'flex', flexDirection: 'column' };
	}
	if (props.dfcolac === true) {
		style = { ...style, display: 'flex', flexDirection: 'column', alignItems: 'center' };
	}
	if (props.jcc === true) {
		style = { ...style, justifyContent: 'center' };
	}
	if (props.h100 === true) {
		style = { ...style, height: '100%' };
	}
	if (props.w100 === true) {
		style = { ...style, width: '100%' };
	}
	if (props.w50 === true) {
		style = { ...style, width: '50%' };
	}
	if (props.w30 === true) {
		style = { ...style, width: '30%' };
	}
	if (props.w33 === true) {
		style = { ...style, width: '33%' };
	}
	if (props.w70 === true) {
		style = { ...style, width: '70%' };
	}
	if (props.pointer === true) {
		style = { ...style, cursor: 'pointer' };
	}
	if (props.borderBottomDivider === true) {
		style = { ...style, borderBottom: '1px solid gray' };
	}
	if (props.errorBorder === true) {
		style = { ...style, borderBottom: '2px solid red', borderRadius: '16px' };
	}
	if (props.mxauto === true) {
		style = { ...style, marginLeft: 'auto', marginRight: 'auto' };
	}
	if (props.popout === true) {
		style = { ...style, marginLeft: '-8px', marginRight: '-8px', padding: '16px', border: '1px solid gray', borderRadius: '8px' };
	}
	if (props.popoverForm === true) {
		style = { ...style, padding: '16px', gap: '16px', width: '100%', height: '100%' };
	}
	return style;
}

const ColumnStack = forwardRef<HTMLDivElement, ColumnStackProps>((props, ref) => {
	return (
		<div
			children={props.children}
			onClick={props.onClick}
			ref={ref}
			style={calculateStyle(props)}
		/>
	);
});

export default ColumnStack;
